import { PAYMENT_STATUS } from './constants';

export const handleRedirect = (urlRedirect: string) => {
  try {
    (window.top ?? window).location.href = urlRedirect;
  } catch {
    // A cross-origin iframe without a user gesture can't navigate the top window (e.g. Shopify's checkout),
    // so the redirect happens inside the frame.
    window.location.href = urlRedirect;
  }
};

export const handleEvents = (payment_status: PAYMENT_STATUS, response: any) => {
  const serializedObject = JSON.parse(JSON.stringify(response));
  window.parent.postMessage(
    {
      payment_status,
      ...(payment_status === PAYMENT_STATUS.paid ? { order: serializedObject } : { error: serializedObject }),
    },
    '*',
  );
};

export const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const RETRY_DELAY_MS = 500;
